WL.registerComponent('hide-rays', {
}, {
    start: function() {
        this.ray = this.object.getComponent('mesh');
        window.SW.gameState.stateSubject.subscribe((state)=>{
            this.ray.active = state !== State.gameplay;
        });
    }    
});
